<script>
    import Datepicker from 'vuejs-datepicker';
    import Spinner from 'vue-simple-spinner';
    import {it} from 'vuejs-datepicker/dist/locale'
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            sourceValidation: String,
            source: String,
            items : {},
            data: {
                type: Object,
                default() {
                    return {
                        first_name: '',
                        email: ''
                    }
                }
            },
            limitCharacters: {
                type: Number,
                default: 55
            }
        },
        components: {Datepicker,Spinner},
        data() {
            return {
                step: 'preview',
                date: '',
                cart: new Form({
                    type: 'App\\CustomGiftCard',
                    buyable: {}
                }),
                form: new Form({
                    email: '',
                    preview_image: '03-Card-classico.png',
                    first_name: '',
                    message: '',
                    sending: 'christmas',
                    sending_date: '',
                    price: '',
                    qty: '',
                    gift_card_id: ''
                }),
                it: it
            }
        },
        computed: {
            charactersLeft() {
                let limit = this.limitCharacters - this.form.message.length;
                return `${limit}/${this.limitCharacters} caratteri rimanenti`
            },
            isPreview() {
                return this.step == 'preview'
            },
            isDefault() {
                return this.form.sending == 'christmas'
            },
            isCustom() {
                return this.form.sending == 'custom'
            },
            isManual() {
                return this.form.sending == 'manual'
            },
            backgroundPreview() {
                return "/images/giftcards/previews/" + this.form.preview_image;
                /*return { backgroundImage: `url('/images/giftcards/previews/${this.form.preview_image}')` };*/
            },
            disabledDates() {
                return {
                    to: new Date()
                }
            }
        },
        watch: {
            date(val) {
                let formatDate = moment(new Date(val)).format('YYYY-MM-DD');
                this.$set(this.form, 'sending_date', formatDate);
            },
            'form.sending': {
                handler(val) {
                    if (val == 'manual') {
                        this.$set(this.form, 'sending_date', null);
                    }
                    if (val == 'christmas') {
                        this.$set(this.form, 'sending_date', this.form.originalData.sending_date)
                    }
                }
            }
        },
        mounted() {
            let vm = this
            $("#giftCardModal").on('hidden.bs.modal', function(e) {
                vm.form.reset()
                vm.setDefaultSending()
                vm.$bus.$emit('reset-card')
            })
        },
        created() {
            this.setDefaultSending()
            this.$bus.$on('update-item', this.updateItem)
        },
        methods: {
            checkLimit(evt) {
                if (this.form.message.length >= this.limitCharacters) {
                    if (evt.keyCode >= 48 && evt.keyCode <= 90) {
                        evt.preventDefault()
                        return
                    }
                }
            },
            nextStep() {
                this.form
                    .submit('post', this.sourceValidation, {}, true)
                    .then(response => this.$set(this, 'step', 'sending'))
            },
            updateItem(item) {
                console.log(item);
                this.$set(this.form, 'price', item.price);
                this.$set(this.form, 'qty', 1);
                this.$set(this.form, 'gift_card_id', item.id);
            },
            setDefaultSending() {
                let d = new Date
                this.$set(this.form, 'sending_date', `${d.getFullYear()}-12-25`)
                this.$set(this, 'step', 'preview')

                if (this.data) {
                    this.$set(this.form, 'first_name', this.data.first_name)
                }
            },
            addToCart({custom}) {
                this.$set(this.cart, 'buyable', custom)

                this.cart
                    .submit('post', 'addToCart')
                    .then((response) => {
                        $("#giftCardModal").modal('hide')
                        window.alerts.success('Elemento aggiunto al carrello');
                        window.location = '/carts'
                    })
            },
            onConfirm() {
                this.form
                    .submit('post', this.source)
                    .then(response => {
                        this.addToCart(response)
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftCardModal.vue